import React from 'react';
// import ButtonDialog from '@its/components/lib/Presentational components/ButtonDialog/ButtonDialog';
import WisywigForm from './WysiwygForm';
import FontIcon from 'material-ui/FontIcon';
// import { Tutorial } from '../../i18n/intl';
import { invalidFormatText } from '@its/components/lib/util/i18n';
import {
  merge,
  isSafari,
  isChrome,
} from '@its/util';
import {
  sortByRowNum,
  getFirstLineDisplayMap,
  getDisplayMaps,
  frameIteration,
  frameButton,
  frameId,
} from './util';

const testFirstLine = (string) => /_[0-9]+_[0-9]+_firstLine/.test(string);
const testField = (string) => /_[0-9]+_[0-9]+/.test(string);

const indicatorList = [
  {
    primaryText: <FontIcon className="material-icons" color="#C0C0C0">block</FontIcon>,
    value: '0',
  }, {
    primaryText: <FontIcon className="material-icons" color="#64DD17">arrow_upward</FontIcon>,
    value: '1',
  }, {
    primaryText: <FontIcon className="material-icons" color="#FF4D4D">arrow_downward</FontIcon>,
    value: '2',
  }, {
    primaryText: (
      <div>
        <FontIcon className="material-icons" color="#64DD17">arrow_upward</FontIcon>
        <FontIcon className="material-icons" color="#FF4D4D">arrow_downward</FontIcon>
      </div>
    ),
    value: '3',
  },
];

const setCurrentValue = (displayMaps, prop, value) => {
  const ids = prop.split('_');
  for (const displayMap of displayMaps) {
    if (displayMap.frame == ids[1] && displayMap.id == ids[2]) {
      displayMap.currentValue = value;
    }
  }
};

const formatFirstLineValue = (value) => {
  let formattedValue = null;
  if (value) {
    const matches = value.match(/^(?:(?:\#font\=(?:big|normal)\;)|(?:\#type\=(?:static|scroll)(?:\,\d{1,})?\;)|(?:\#effect\=(?:blink|stop)\;)){0,}((?:.){1,})(?:\§|$)/);
    if (Array.isArray(matches)) {
      formattedValue = matches[1];
    } else {
      formattedValue = '---';
    }
  }
  return formattedValue;
};

const getWisywigField = (currentRow, displayMap, displayTemplateMap) => {
  const fields = {};
  const initialValues = {};
  let newLine = false;
  if (currentRow !== displayTemplateMap.rowNum) {
    newLine = true;
    currentRow = displayTemplateMap.rowNum;
  }
  const isIndicator = displayTemplateMap.specialFeatures - 8 >= 0;
  const isFirst = displayTemplateMap.rowNum == 1 && displayTemplateMap.fieldNum == 1;
  let textShadow = null;
  let WebkitTextStroke = null;
  switch (displayTemplateMap.color) {
    case '#F9EF00':
      textShadow = '-1px 0 #FFEB3B';
      break;
    case '#FF3D00':
      if (isSafari || isChrome) {
        WebkitTextStroke = '1px #ff6161';
      } else {
        textShadow = '-1px -1px 0 #ff6161, 1px -1px 0 #ff6161, -1px 1px 0 #ff6161, 1px 1px 0 #ff6161';
      }
      break;
    default:
  }
  let type = null;
  if (isIndicator) {
    type = 'select';
  } else if (isFirst) {
    type = 'formattableTextField';
  }
  let fieldName = `_${displayMap.frame}_${displayMap.id}`;
  if (isFirst) {
    fieldName += '_firstLine';
  }
  fields[fieldName] = {
    maxLength: !isFirst ? displayTemplateMap.width : null,
    type,
    formatValue: isFirst ? formatFirstLineValue : null,
    items: isIndicator ? indicatorList : null,
    autoWidth: isIndicator || null,
    newLine,
    labelStyle: isIndicator ? { height: '35px' } : { color: displayTemplateMap.color },
    disabled: displayMap.sourceType === 2,
    validators: {
      required: isIndicator,
      regex: !isFirst ? null : {
        message: invalidFormatText,
        value: /^(?:(?:(?:\#font\=(?:big|normal)\;)|(?:\#type\=(?:static|scroll)(?:\,\d{1,})?\;)|(?:\#effect\=(?:blink|stop)\;)){0,}(?:(?:\#(?!(?:font|effect|type))|.|(?:\§(?!$|\§|\=|\;)))){1,}){1,}$/,
      },
    },
    underlineStyle: {
      display: displayMap.sourceType === 2 ? 'none' : null,
      borderColor: 'rgba(255, 255, 255, 0)',
    },
    underlineFocusStyle: {
      borderColor: 'rgba(255, 255, 255, 0)',
    },
    inputStyle: {
      opacity: displayMap.sourceType === 2 ? '0.6' : null,
      cursor: displayMap.sourceType === 2 ? 'not-allowed' : null,
      fontFamily: 'Led',
      fontWeight: 'bold',
      fontSize: '28px',
      font: null,
      color: displayTemplateMap.color,
      textShadow,
      WebkitTextStroke,
    },
    iconStyle: isIndicator ? { top: '9px' } : null,
    iconColor: '#FFFFFF',
    visible: isFirst && displayMap.frame === 1,
    style: {
      height: isIndicator ? '35px' : '18px',
      margin: isFirst ? '10px 0px 10px 48px' : '10px 8px',
      fontWeight: '600',
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      width: isIndicator ? null : `${displayTemplateMap.width * 11}px`,
    },
  };
  initialValues[fieldName] = displayMap.currentValue;
  return {
    fields,
    initialValues,
    currentRow,
  };
};

export default class extends React.Component {

  static propTypes = {
    display: React.PropTypes.object,
    expandDisplayForm: React.PropTypes.bool,
    hideCancel: React.PropTypes.bool,
    setAppBar: React.PropTypes.bool,
  }

  static defaultProps = {
    hideCancel: false,
  }

  constructor(props, context) {
    super(props, context);
    this.onSubmit = (display, templates, values) => {
      const displayMaps = [...display.displayMaps];
      const displayFramesIteration = [...display.displayFramesIteration];
      let firstLineValue = '';
      for (const template of templates) {
        if (template.adapterNum == 1) {
          const displayMap = getFirstLineDisplayMap(displayMaps, template.id);
          firstLineValue = values[`_1_${displayMap.id}_firstLine`];
        }
      }
      for (const prop in values) {
        if (frameIteration.test(prop)) {
          const frame = prop.split('_')[1];
          for (const displayFrameIteration of displayFramesIteration) {
            if (displayFrameIteration.frame == frame) {
              displayFrameIteration.iterationId = values[prop];
            }
          }
          delete values[prop];
        } else if (frameButton.test(prop) || frameId.test(prop)) {
          delete values[prop];
        } else {
          if (testFirstLine(prop)) {
            setCurrentValue(displayMaps, prop, firstLineValue);
            delete values[prop];
          } else if (testField(prop)) {
            setCurrentValue(displayMaps, prop, values[prop]);
            delete values[prop];
          }
        }
      }
      const result = Object.assign({}, display, values);
      if (values.templateId && values.templateId != display.templateId) {
        delete result.displayMaps;
      } else if (values.frames && values.frames != display.frames) {
        result.displayMaps = displayMaps;
        for (let i = 0; i < result.displayMaps.length; i++) {
          if (result.displayMaps[i].frame > values.frames) {
            result.displayMaps.splice(i, 1);
            i--;
          }
        }
      } else {
        result.displayMaps = displayMaps;
      }
      result.displayFramesIteration = displayFramesIteration;
      result.currentFrame = null;
      result.forceUpdate = true;
      return result;
    };

    this.appBar = {
      title: 'DISPLAY',
      navigateBack: true,
      /* iconElementRight: (
        <ButtonDialog
          type="icon"
          icon="help"
          iconStyle={{ color: '#FFFFFF' }}
          dialog={ {
            title: 'LEGEND',
            cancel: true,
            content: Tutorial,
            autoScrollBodyContent: true,
          } }
        />
      ), */
    };

    this.getWysiwyg = (displayMaps, displayTemplateMaps) => {
      const fields = [];
      let initialValues = {};
      const currentRow = [];
      displayTemplateMaps.sort(sortByRowNum);
      for (const displayTemplateMap of displayTemplateMaps) {
        const displayMapFrames = getDisplayMaps(
          displayMaps,
          displayTemplateMap.id,
        );
        for (let i = 0; i < displayMapFrames.length; i++) {
          if (!fields[displayMapFrames[i].frame]) {
            fields[displayMapFrames[i].frame] = { fields: {} };
          }
          if (!currentRow[displayMapFrames[i].frame]) {
            currentRow[displayMapFrames[i].frame] = 1;
          }
          const wysiwygField = getWisywigField(currentRow[displayMapFrames[i].frame], displayMapFrames[i], displayTemplateMap);
          fields[displayMapFrames[i].frame].fields = merge(fields[displayMapFrames[i].frame].fields, wysiwygField.fields);
          initialValues = merge(initialValues, wysiwygField.initialValues);
          currentRow[displayMapFrames[i].frame] = wysiwygField.currentRow;
        }
      }
      return {
        fields,
        initialValues,
      };
    };
  }

  render() {
    return (
      <WisywigForm
        getWysiwyg={this.getWysiwyg}
        onSubmit={this.onSubmit}
        appBar={this.appBar}
        selectedObject={this.props.display}
        expandDisplayForm={this.props.expandDisplayForm}
        hideCancel={this.props.hideCancel}
        setAppBar={this.props.setAppBar}
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Display/Display.js
 **/